import { getAllEntitiesAtPath } from 'app/infrastructure/store';
import { tableName } from 'app/area/case/case-data-model';
import { getCaseData } from 'app/infrastructure/ui/renderer/resolvers';
import { CaseState } from 'app/area/case/types-store';
import { InitialUiEngineProps } from 'app/infrastructure/ui/types-uischema';

interface ConnectedCaseIdsProps extends InitialUiEngineProps {
  connectionTypeId?: number;
}

export const connectedCasesIds = (caseState: CaseState, uiEngineProps: ConnectedCaseIdsProps) => {
  const connectionTypeId = uiEngineProps.connectionTypeId || 
                           uiEngineProps.componentDescriptor.properties.connectionTypeId;

  return {
    connectedCasesIds: 
      getAllEntitiesAtPath(
        getCaseData(caseState, uiEngineProps), 
        [tableName.trans, tableName.connectionTypes, tableName.connectedCases]
      )
      .filter(e => e.id.some(i => i[tableName.connectionTypes] === connectionTypeId))
      .map(e => e.primaryKey.value)
  };
};

export const connectedCasesIdsIrrespectiveOfConnectionType = (caseState: CaseState, uiEngineProps: ConnectedCaseIdsProps) => {
  return {
    connectedCasesIds: 
      getAllEntitiesAtPath(
        getCaseData(caseState, uiEngineProps), 
        [tableName.trans, tableName.connectedCasesSummary]
      )
      .map(e => e.primaryKey.value)
  };
};

export interface ConnectedCasesIdsShape {
  connectedCasesIds: any;
}
